import React, { useMemo, useState } from "react";
import { Box, CssBaseline, useMediaQuery, useTheme } from "@mui/material";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import { DataGrid, esES } from "@mui/x-data-grid";
import Topbar from "../../../../components/topbar/TopBar";
import Header from "../../../../components/header/Header";
import Sidebar from "../../../../components/sidebar/Sidebar";
import { tokens } from "../../../../theme";

export const RenovateVehicleListPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const themeSidebar = useMuiTheme();
  const matchesSM = useMediaQuery(themeSidebar.breakpoints.down("sm"));
  const [renovatedVehicles] = useState([]);

  const columns = useMemo(
    () => [
      { field: "id", headerName: "ID", width: 60 },
      {
        headerName: "Marca",
        field: "brand",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 120,
      },
      {
        headerName: "Modelo",
        field: "model",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 120,
      },
      {
        headerName: "Placa",
        field: "plate",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 100,
      },
      {
        headerName: "Año",
        field: "year",
        width: 80,
      },
      {
        headerName: "Color",
        field: "color",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 120,
      },
      {
        headerName: "Carroceria",
        field: "bodywork",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 120,
      },
      {
        headerName: "Revision tecnica",
        field: "technical_review",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 150,
      },
      {
        headerName: "FV REVISION",
        field: "technincal_review_end",
        width: 130,
      },
      {
        headerName: "SOAT",
        field: "soat",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 120,
      },
      {
        headerName: "FV SOAT",
        field: "soat_end",
        width: 120,
      },
    ],
    [],
  );

  return (
    <>
      <CssBaseline />
      <div className="app">
        {!matchesSM && <Sidebar />}
        <main className="content">
          <Topbar />
          <Box m="10px">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Header title="VEHICULOS RENOVADOS" subtitle="" />
            </Box>
            <Box display="grid" gap="10px">
              <Box gridColumn="span 12" gridRow="span 2">
                <Box
                  m="10px 0 0 0"
                  height="100vh"
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[700],
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "none",
                      backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                  }}
                >
                  <DataGrid
                    getRowId={(row) => row.id}
                    rows={renovatedVehicles}
                    columns={columns}
                    localeText={{
                      ...esES.components.MuiDataGrid.defaultProps.localeText,
                      noRowsLabel: "No hay vehiculos renovados",
                    }}
                    checkboxSelection={true}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </main>
      </div>
    </>
  );
};
